import $ from 'jquery';
import AjaxForm from './ajax-form';

const EvaluationForm = function ($form) {
    const evaluationForm = this;

    AjaxForm.call(this, $form);

    evaluationForm.redirect = evaluationForm.$form.data('redirect');
    evaluationForm.conditionalFields = evaluationForm.$form.data('conditionalFields') ?? {};
    evaluationForm.$submitButtons = $(evaluationForm.$form[0].elements).filter(':submit');
    evaluationForm.profileForm = $('#' + evaluationForm.$form.data('profileFormId')).profileForm();

    // Initialize enabled/disabled state of conditional fields
    for (const name in evaluationForm.conditionalFields) {
        evaluationForm.handleConditionalFields(name, 0);
    }

    // Bind form submission
    evaluationForm.$form.on('submit.evaluationForm', function (event) {
        event.preventDefault();

        const $button = $(event.originalEvent.submitter);
        $button.addClass('is-pending');

        $.when(evaluationForm.handleQueue(), evaluationForm.profileForm.handleQueue())
            .then(function () {
                const $invalidInput = $(evaluationForm.$form[0].elements).filter(':input[name].is-invalid').first();

                if ($invalidInput.length) {
                    $invalidInput.trigger('focus');
                    evaluationForm.getFields($invalidInput)[0].scrollIntoView(true);
                } else {
                    location.href = evaluationForm.redirect;

                    // Keep button in "pending" state while redirect page is loading
                    return $.Deferred();
                }
            })
            .then(() => $button.removeClass('is-pending'));
    });
};

EvaluationForm.prototype = Object.create(AjaxForm.prototype);

EvaluationForm.prototype.getInputName = function ($input) {
    return $input.prop('name').replace(/\[]$/, '');
};

EvaluationForm.prototype.getRelatedInputNames = function ($inputs) {
    const evaluationForm = this;

    return [...new Set(
        evaluationForm.getInputNames($inputs)
            .map(name => [name, ...Object.values(evaluationForm.conditionalFields[name] ?? {}).flat()])
            .flat()
    )];
};

EvaluationForm.prototype.handleChangedInputs = function ($inputs) {
    const evaluationForm = this;

    // Handle related conditional fields
    for (const name of evaluationForm.getInputNames($inputs)) {
        evaluationForm.handleConditionalFields(name);
    }

    return AjaxForm.prototype.handleChangedInputs.call(this, $inputs);
};

EvaluationForm.prototype.handleAjaxResponse = function (response) {
    const evaluationForm = this;

    for (const name in response) {
        const $responseInputs = evaluationForm.getInputsByName(name);
        const $visualInputs = $responseInputs.filter(evaluationForm.processing.$inputs)
            .add($responseInputs.filter('.is-invalid'));

        if (response[name] === true) {
            evaluationForm.showInputsAsValid($visualInputs);
        } else {
            evaluationForm.showInputsAsInvalid($visualInputs, response[name]);
        }
    }

    return null;
};

EvaluationForm.prototype.handleConditionalFields = function (name, duration) {
    const evaluationForm = this;

    if (! name in evaluationForm.conditionalFields) {
        return;
    }

    const conditions = evaluationForm.conditionalFields[name];
    const $inputs = evaluationForm.getInputsByName(name);
    const $field = evaluationForm.getFields($inputs);
    const value = evaluationForm.getInputsData($inputs)[0]?.value ?? '';

    for (const condition in conditions) {
        const conditionValues = condition.split('|');
        const $relatedInputs = evaluationForm.getInputsByName(conditions[condition]);
        const $relatedFields = evaluationForm.getFields($relatedInputs);

        if (conditionValues.includes(value)) {
            // Condition is satisfied
            // Enable fields
            $relatedFields.removeClass('disabled');
            $relatedFields.find(':input').prop('disabled', false).trigger('changeDisabled.sysVision', false);

            // Hide tooltips
            $relatedFields.children('.form-field-content').tooltip('dispose');

            // Show fields
            $relatedFields.filter('.hidden-when-disabled').stop().slideDown(duration);
        } else {
            // Condition is unsatisfied
            // Clear field values
            evaluationForm.clearInputs($relatedInputs);

            // Disable fields
            $relatedFields.addClass('disabled');
            $relatedFields.find(':input').prop('disabled', true).trigger('changeDisabled.sysVision', true);

            // Show tooltips
            $relatedFields.children('.form-field-content').tooltip({
                title: evaluationForm.computeConditionText($field, conditionValues),
                placement: 'left',
            });

            // Hide fields
            $relatedFields.filter('.hidden-when-disabled').stop().slideUp(duration);
        }
    }
};

EvaluationForm.prototype.getLabelText = function ($label, capitalized) {
    let labelText = $label.text().trim();

    if (! capitalized) {
        labelText = labelText[0].toLowerCase() + labelText.slice(1);
    }

    return labelText;
};

EvaluationForm.prototype.computeConditionText = function ($field, conditionValues) {
    const evaluationForm = this;

    let text = 'Requiert ';
    text += evaluationForm.getLabelText($field.children('.form-field-content').children('.form-label').contents().eq(0));
    text += '\u00a0: ';

    for (let i = 0; i < conditionValues.length; i++) {
        if (i) {
            if (i === conditionValues.length - 1) {
                text += ' ou '
            } else {
                text += ', '
            }
        }

        text += evaluationForm.getLabelText($field.find([
            'option[value=' + $.escapeSelector(conditionValues[i]) + ']',
            'input[value=' + $.escapeSelector(conditionValues[i]) + '] + label',
        ].join(',')));
    }

    text += '.';

    return text;
};

$.fn.evaluationForm = function () {
    this.each(function () {
        const $form = $(this);

        if (! $form.data('evaluationForm')) {
            $form.data('evaluationForm', new EvaluationForm($form));
        }
    });

    return this.data('evaluationForm');
};

$(function () {
    $('.evaluation-form').evaluationForm();
});

export default EvaluationForm;
